import breakpoint from "../../assets/scss/breakpoint.module.scss";
import React, { useEffect, useState } from 'react';
import Image from 'react-bootstrap/Image';
import { Col, Container, Row } from 'react-bootstrap';
import "../../assets/scss/project/show-case-mobile.scss"
import IShowCaseTypes from '../../models/IShowCaseTypes';
import { IImage } from '../../models/IScreen';
import getExtension from "service/script/getExtention";
import { LazyLoadComponent } from "react-lazy-load-image-component";

export interface IScreenMobile extends IImage {
    type: IShowCaseTypes.mobile;
}

interface props {
    screens: Array<IScreenMobile>
}


function getWindowDimensions() {
    const { innerWidth: width, innerHeight: height } = window;
    return {
        width,
        height
    };
}

export function useWindowDimensions() {
    const [windowDimensions, setWindowDimensions] = useState(
        getWindowDimensions()
    );

    useEffect(() => {
        function handleResize() {
            setWindowDimensions(getWindowDimensions());
        }

        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    return windowDimensions;
}


function ProjectShowCaseMobile(props: props) {
    const { height, width } = useWindowDimensions();
    const breakpointSm = Number(/[0-9]+/g.exec(breakpoint.sm));
    const screenAmount = props.screens.length;

    const distImagesDiag = props.screens.map((el: any, index: number): string => {
        if (screenAmount !== 1 && width <= breakpointSm) {
            const maxMove = 60;
            const oneUnit = (maxMove * 2) / screenAmount;
            const pos = (oneUnit * index) - (screenAmount - 1) * oneUnit * 0.5;
            return `translate(${pos}%)`;
        }


        return `translate(0%)`;
    });


    const screens: Array<JSX.Element> = props.screens.map((screen: IImage, index: number) => {
        const imgStyle = {
            transform: distImagesDiag[index],
        }




        return (
            getExtension(screen.src) === "mp4" ?

                <video key={index} className="show-case-item tablet rounded-corners" loop autoPlay muted preload='auto'>
                    <source src={screen.src} type="video/mp4" />
                </video>
                :
                <Image key={index} fluid style={imgStyle} className="show-case-item mobile rounded-corners" alt={screen.alt} src={screen.src} />

        )
    })

    return (
        <Container >
            <Row>
                <Col>
                    <div className="show-case">
                        <LazyLoadComponent threshold={500}>

                            {screens}
                        </LazyLoadComponent>
                    </div>
                </Col>
            </Row>
        </Container>
    );
}

export default ProjectShowCaseMobile;